import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import { HelpSection, DEFAULT_SCORE_INFO } from '../services/residentHelpContentService';
import { useAppScrollLock } from '../hooks/useAppScrollLock';
import { useDialogA11y } from '../hooks/useDialogA11y';
import './ScoreInfoDialog.css';

interface ScoreInfoDialogProps {
  isOpen: boolean;
  onClose: () => void;
  sections?: HelpSection[];
}

export const ScoreInfoDialog: React.FC<ScoreInfoDialogProps> = ({
  isOpen,
  onClose,
  sections = DEFAULT_SCORE_INFO,
}) => {
  useAppScrollLock(isOpen);
  const dialogRef = useRef<HTMLDivElement>(null);
  useDialogA11y({ isOpen, onClose, dialogRef });

  if (!isOpen) return null;

  return createPortal(
    <div className="help-dialog-backdrop" onClick={onClose}>
      <div
        ref={dialogRef}
        tabIndex={-1}
        className="help-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="score-info-dialog-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="help-dialog__header">
          <h2 className="help-dialog__title" id="score-info-dialog-title">About your scores</h2>
          <button
            type="button"
            className="help-dialog__close"
            onClick={onClose}
            aria-label="Close dialog"
          >
            ×
          </button>
        </div>
        <div className="help-dialog__body">
          {sections.map((s, i) => (
            <section className="help-dialog__section" key={i}>
              <h3 className="help-dialog__question">{s.question}</h3>
              <p className="help-dialog__answer">{s.answer}</p>
            </section>
          ))}
        </div>
      </div>
    </div>,
    document.body
  );
};
